module.exports = __webpack_public_path__ + "img/hyundai.svg";